import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from '../../service/local-storage.service';
import { MainService } from '../../service/main.service';
import { ToasterServiceService } from '../../service/toaster.service';
import { ApiUrls } from '../../apiRouts';
import { DatePipe } from '@angular/common';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-custom-reminder',
  templateUrl: './custom-reminder.component.html',
  styleUrl: './custom-reminder.component.scss'
})
export class CustomReminderComponent {
  customReminderForm: any = FormGroup;
  buttonclick: boolean = false;
  customHistoryData: any;
  submitted = false;
  userId: any;
  datePipe = new DatePipe("en-US")
  maxDate: Date = new Date();
  selectedName: any = '';
  @ViewChild('formContainer') formContainer!: ElementRef;

  constructor(
    private fb: FormBuilder,
    private localStorageService: LocalStorageService,
    private mainService: MainService,
    public dialog: MatDialog,
    private renderer: Renderer2,
    private toasterService: ToasterServiceService
  ) {
    this.userId = JSON.parse(localStorageService.getItem("loginData") || '{}').user_id;
    this.customReminderForm = this.fb.group({
      custom_reminder_id: [0],
      start_time: ['', Validators.required],
      remarks: [''],
      reminder_type: [''],
      date: [''],
    })
  }

  ngOnInit() {
    this.getCustomList();
  }

  get f() {
    return this.customReminderForm.controls;
  }

  getCustomList() {
    this.mainService.getApi(ApiUrls.customReminderDetail + this.userId).subscribe((res: any) => {
      if (res.status === 1) {
        this.customHistoryData = res.custom_reminder.map((item: any) => ({
          ...item,
          is_active: +item.is_active
        }));
      }
    });
  }

  convertTo12HourFormat(time: string): string {
    const [hour, minute, second] = time.split(':');
    const period = +hour >= 12 ? 'PM' : 'AM';
    const hour12 = +hour % 12 || 12;
    return `${hour12}:${minute}:${second} ${period}`;
  }

  editCustomData(data: any) {
    this.buttonclick = true;
    let dateTime = data.start_time;
    let time = dateTime.split(' ')[1];
    let time1 = dateTime.split(' ')[2];
    let date = dateTime.split(' ')[0];
    const formattedDate = new Date(date);
    const startTime = this.extractHourAndMinute(`${time} ${time1}`);
    this.customReminderForm.patchValue({
      start_time: startTime,
      date: formattedDate,
      remarks: data.remarks,
      reminder_type: data.reminder_type,
      custom_reminder_id: data.custom_reminder_id,
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      if (this.formContainer && this.formContainer.nativeElement) {
        this.renderer.selectRootElement(this.formContainer.nativeElement).focus();
      }
    }, 300);
  }

  extractHourAndMinute(time: string): string {
    const [hourMinute, amPm] = time.split(' ');
    const [hour, minute] = hourMinute.split(':');
    return `${hour}:${minute} ${amPm}`;
  }

  openDialog(e: any, data: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page: 'JobList'
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.deleteCustomData(data);
      } else {
        e.source.checked = !e.checked;
        data.status = e.checked == true ? 0 : 1;
      }
    });
  }

  deleteCustomData(value: any) {
    let data = {
      custom_reminder_id: Number(value.custom_reminder_id),
      user_id: this.userId,
      start_time: "",
      reminder_type: value.reminder_type,
      remarks: "",
      created: String(this.localStorageService.getItem('user_id')),
      is_active: String(value.is_active ? 1 : 0),
      Action: 'IS_ACTIVE',
    };
    this.mainService.postApi(ApiUrls.addEditCustomReminder, data, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.toasterService.toastSuccess(res.response);
        this.getCustomList();
      } else {
        this.toasterService.toastError(res.response);
      }
    });
  }

  private convertTimeTo24HourFormat(time: string): string {
    let [timePart, modifier] = time.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);

    if (modifier === 'PM' && hours < 12) {
      hours += 12;
    } else if (modifier === 'AM' && hours === 12) {
      hours = 0;
    }

    let formattedHours = hours.toString().padStart(2, '0');
    let formattedMinutes = minutes.toString().padStart(2, '0');
    return `${formattedHours}:${formattedMinutes}:00`;
  }

  addMedicineReminder() {
    this.submitted = true;
    if (this.customReminderForm.valid) {
      let startTime = this.customReminderForm.value.start_time;
      let date = this.customReminderForm.value.date;
      let formattedTime = this.convertTimeTo24HourFormat(startTime);
      let formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd');
      let formattedDateTime = `${formattedDate} ${formattedTime}`;
      let data = {
        custom_reminder_id: 0,
        user_id: this.userId,
        start_time: formattedDateTime,
        reminder_type: this.customReminderForm.value.reminder_type,
        title: "",
        remarks: this.customReminderForm.value.remarks,
        created: String(this.localStorageService.getItem('user_id')),
        is_active: "1",
        Action: "INSERT",
      };
      this.mainService.postApi(ApiUrls.addEditCustomReminder, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.customReminderForm.reset();
          this.selectedName = '';
          this.submitted = false;
          this.getCustomList();
          this.toasterService.toastSuccess(res.response);
        } else {
          this.toasterService.toastError(res.response);
        }
      })
    }
    else {
      this.submitted = true;
    }
  }

  editMedicineReminder() {
    let startTime = this.customReminderForm.value.start_time;
    let date = this.customReminderForm.value.date;
    let formattedTime = this.convertTimeTo24HourFormat(startTime);
    let formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd');
    let formattedDateTime = `${formattedDate} ${formattedTime}`;
    let data = {
      custom_reminder_id: this.customReminderForm.value.custom_reminder_id,
      user_id: this.userId,
      start_time: formattedDateTime,
      reminder_type: this.customReminderForm.value.reminder_type,
      title: "",
      remarks: this.customReminderForm.value.remarks,
      created: String(this.localStorageService.getItem('user_id')),
      is_active: "1",
      Action: "UPDATE",
    };
    if (this.customReminderForm.valid) {
      this.mainService.putApi(ApiUrls.addEditCustomReminder, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.customReminderForm.reset();
          this.selectedName = '';
          this.submitted = false;
          this.buttonclick = false;
          this.getCustomList();
          this.toasterService.toastSuccess(res.response);
        }
      });
    } else {
      this.submitted = true
      this.buttonclick = true;
    }
  }
}